import React from 'react';

export const MainCustomerCenter = () => (
  <section className="main-customer-center">
    <div className="tel">
      <span>24시간운영 고객센터</span>
      <a href="tel:1688-1011">1688-1011</a>
    </div>
    <div className="kakao">
      <img src="/image/layout/kakao.svg" alt="" />
      카카오톡 친구찾기 ‘라이엇 게임즈 PC방 고객센터’ 검색
    </div>
  </section>
);
